module.exports = __webpack_public_path__ + "static/media/medical-consult-doctors.05054ed9.jpg";